import { ProcessInfo } from '@components/approver-parent-consent/process-info/process-info';
import './approver-parent-consent-page.scss';
import { AccountForChildProductBullets } from '@components/account-for-child-product-bullets/account-for-child-product-bullets';
import { ApproverDocumentConsent } from '@components/approver-parent-consent/approver-document-consent';
import { ApproverParentConsentHeader } from '@components/approver-parent-consent/header/approver-parent-consent-header';
import { EmailInput } from '@components/email-input/email-input';
import { ProcessDetails } from '@components/process-details/process-details';
import { ProcessErrorBoundary } from '@components/process-error-boundary/process-error-boundary';
import { useAccountApprovalActions } from '@hooks/context/use-account-approval-context';
import { useNavigateIfInappropriateApproveAttempt } from '@hooks/navigation/use-navigation-effects';
import { useProcess } from '@react-query/hooks/query/use-process';
import { useTranslation } from '@translations';

export const ApproverParentConsentPage = () => {
    const { isPending } = useProcess();
    const { setApproverParentEmail } = useAccountApprovalActions();
    const { accountForChildProductBullets } = useTranslation();

    useNavigateIfInappropriateApproveAttempt();

    if (isPending) {
        return <ProcessLoading />;
    }

    return (
        <div className="approver-parent-consent-page">
            <ApproverParentConsentHeader />
            <ProcessErrorBoundary>
                <AccountForChildProductBullets header={accountForChildProductBullets.header} />
                <ProcessInfo />
                <EmailInput setValue={setApproverParentEmail} />
                <ApproverDocumentConsent />
            </ProcessErrorBoundary>
        </div>
    );
};

const ProcessLoading = () => (
    <div className="approver-parent-consent-page" data-testid="loading-approver-parent-consent">
        <ApproverParentConsentHeader />
        <ProcessDetails isLoading skeletonCount={4} />
    </div>
);
